import React, {useEffect, useState} from 'react'
import Button from '@components/V3/Button'
import Text from '@components/V3/forms/Text'
import Notice from '@components/V3/Notice'
import usePreferences from '@page-components/CheckoutV3/hooks/usePreferences.main'
import {useTranslation} from 'next-i18next'
import {Field, Form} from 'simple-react-form'

import useCoupon from './useCoupon'

export default function Edit() {
  const {t} = useTranslation('checkoutv3', {keyPrefix: 'coupon'})
  const {preferences} = usePreferences()
  const {t: tGeneric} = useTranslation('generic')
  const [code, setCode] = useState(preferences.couponCode)
  const {submit, errorMessage, couponExists, loading, submittedThisSession} = useCoupon(preferences)

  useEffect(() => {
    if (errorMessage) {
      submit({code: null})
      setCode(null)
    }
  }, [])

  const couponApplied = !!preferences.couponCode && couponExists

  return (
    <Form onSubmit={() => submit({code})}>
      <div className="flex mt-3 md:mt-0 md:mb-4">
        <div className="flex-1 sm:w-auto md:w-1/2 lg:w-auto">
          <Field
            fieldName="code"
            disabled={loading || couponApplied}
            value={code}
            error={!loading && !!errorMessage}
            success={!loading && !errorMessage && couponExists}
            onChange={code => setCode((code || '').toUpperCase())}
            type={Text}
            placeholder={t('placeholder')}
          />
        </div>
        <div className="flex">
          {couponApplied ? (
            <Button
              disabled={loading}
              loading={loading}
              className="ml-2 w-24"
              onClick={() => {
                setCode(null)
                submit({code: null})
              }}>
              {loading ? null : tGeneric('fields.discard')}
            </Button>
          ) : (
            <Button
              disabled={loading}
              loading={loading}
              className="ml-2 w-24"
              primary
              onClick={() => submit({code})}>
              {loading ? null : tGeneric('fields.apply')}
            </Button>
          )}
        </div>
      </div>
      {(errorMessage || (couponExists && submittedThisSession)) && !loading && (
        <div className="mt-3 md:mb-3">
          {errorMessage && <Notice level="error">{errorMessage}</Notice>}
          {couponExists && submittedThisSession && (
            <Notice level="success">
              {t('success', {couponName: preferences.cart?.couponStatus?.name})}
            </Notice>
          )}
        </div>
      )}
    </Form>
  )
}
